import { cva, type VariantProps } from 'class-variance-authority';
import { Progress as ProgressPrimitive } from 'radix-ui';
import * as React from 'react';

import { cn } from '@savgroup-front-common/primitive/lib/utils';

export const progressVariants = cva(
  'relative flex h-1.5 w-full items-center overflow-x-hidden rounded-full',
  {
    variants: {
      track: {
        default: 'bg-surface-disabled-default',
        subtle: 'bg-surface-primary-subtle-default',
      },
    },
    defaultVariants: {
      track: 'default',
    },
  },
);

export const progressIndicatorVariants = cva(
  'size-full flex-1 transition-all',
  {
    variants: {
      indicator: {
        default: 'bg-surface-primary-default',
        subtle: 'bg-surface-primary-subtle-active',
      },
    },
    defaultVariants: {
      indicator: 'default',
    },
  },
);

export function Progress({
  className,
  value,
  track = 'default',
  indicator = 'default',
  ...props
}: React.ComponentProps<typeof ProgressPrimitive.Root> &
  VariantProps<typeof progressVariants> &
  VariantProps<typeof progressIndicatorVariants>) {
  return (
    <ProgressPrimitive.Root
      data-slot="progress"
      data-track={track}
      className={cn('revers-progress', progressVariants({ track }), className)}
      value={value}
      {...props}
    >
      <ProgressPrimitive.Indicator
        data-slot="progress-indicator"
        data-indicator={indicator}
        className={cn(
          'revers-progress-indicator',
          progressIndicatorVariants({ indicator }),
        )}
        style={{ transform: `translateX(-${100 - (value || 0)}%)` }}
      />
    </ProgressPrimitive.Root>
  );
}
